import React from 'react';
import {Container} from './styles';
import {theme} from '../../../../styles/darkTheme';

const ChatFooter: React.FC<{children: React.ReactNode}> = ({children}) => {
  return <Container theme={theme}>{children}</Container>;
};

export default ChatFooter;
